import router from '../../router'
import DocumentService from '../../services/DocumentService'

const state = () => ({
    loadingDocuments: false,
    document: null,
    documents: [],
    total: 0,
    pages: 0,
    page: 1,
    show_modal_new_document: false
})
  
const mutations = {
    SET_DOCUMENT: (state, payload) => {
        state.document = payload
    },
    SET_DOCUMENTS: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.documents = payload.items
        }else{
            state.documents = [...state.documents, ...payload.items]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total

    },
    SET_LOADING_DOCUMENTS: (state, payload) => {
        state.loadingDocument = payload
    },
    SET_SHOW_MODAL_DOCUMENT: (state, payload) => {
        state.show_modal_new_document = payload
    },
}

const actions = {
    async fetchDocument({commit}, id){
        try{
            commit('SET_LOADING_DOCUMENTS', true)
            const response = await DocumentService.getOne(id);
            commit('SET_DOCUMENT', response.data)
            commit('SET_LOADING_DOCUMENTS', false)
        } catch (error) {
            commit('SET_LOADING_DOCUMENTS', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchDocuments({commit}, params = {}){
        try{
            commit('SET_LOADING_DOCUMENTS', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'ASC' } } = params;
            const response = await DocumentService.get(keyword, pageNumber, pageSize, order);
            commit('SET_DOCUMENTS', response.data)
            commit('SET_LOADING_DOCUMENTS', false)
        } catch (error) {
            commit('SET_LOADING_DOCUMENTS', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createDocument({commit}, data){
        try{
            commit('SET_LOADING_DOCUMENTS', true)
            const response = await DocumentService.create(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_SHOW_MODAL_DOCUMENT', false)
            commit('SET_LOADING_DOCUMENTS', false)
        } catch (error) {
            commit('SET_LOADING_DOCUMENTS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updadeDocument({commit}, data){
        try{
            commit('SET_LOADING_DOCUMENTS', true)
            const response = await DocumentService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_DOCUMENTS', false)
        } catch (error) {
            commit('SET_LOADING_DOCUMENTS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getDocument: state => state.document,
    getDocuments: state => state.documents,
    getLoadingDocument: state => state.loadingDocument,
    getShowModalNewDocument: state => state.show_modal_new_document
}

export default {
    state,
    getters,
    mutations,
    actions
};